import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API from "../../services/api";
import "./ApplicationStatus.css";

function ApplicationStatus() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [provider, setProvider] = useState(null);

  useEffect(() => {
    fetchStatus();

    const interval = setInterval(() => {
      fetchStatus();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const fetchStatus = async () => {
    try {
      const res = await API.get(
        `/provider/application-status/${id}`
      );

      setProvider(res.data.provider);
      console.log("Provider from API:", res.data.provider);
console.log("Activation Token:", res.data.provider.activationToken);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="status-loading">
        Loading Application...
      </div>
    );
  }

  if (!provider) {
    return (
      <div className="status-loading">
        Application Not Found
      </div>
    );
  }

  return (
    <div className="application-status-page">

      <div className="status-container">

        <h1>Application Status</h1>

        <p className="subtitle">
          Track your HomeFoods provider application
        </p>

        <div className="application-business-card">

          <div className="business-name">
            {provider.businessName}
          </div>

          <div className="owner-name">
            Owner : {provider.ownerName}
          </div>

        </div>

        <div className="status-info">

          <div className="info-row">
            <span>Application ID</span>
            <strong>{provider.id}</strong>
          </div>

          <div className="info-row">
            <span>Status</span>

            <strong
              className={
                provider.status.toLowerCase()
              }
            >
              {provider.status}
            </strong>

          </div>

        </div>

        <div className="timeline">

          <div className="timeline-item completed">
            ✅ Application Submitted
          </div>

          <div
            className={`timeline-item ${
              provider.status === "Pending"
                ? "current"
                : "completed"
            }`}
          >
            🔍 Admin Verification
          </div>

          {provider.status === "Approved" && (
            <div className="timeline-item completed">
              ✅ Application Approved
            </div>
          )}

          {provider.status === "Rejected" && (
            <div className="timeline-item rejected">
              ❌ Application Rejected
            </div>
          )}

        </div>

        {provider.status === "Approved" &&
          !provider.passwordCreated && (

            <button
    className="primary-btn"
    onClick={() =>
        window.location.href =
            `/create-password?token=${provider.activationToken}`
    }
>
    Create Password
</button>

          )}

        {provider.passwordCreated && (

          <button
            className="primary-btn"
            onClick={() => navigate("/login")}
          >
            Login
          </button>

        )}

        <button
          className="secondary-btn"
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>

      </div>

    </div>
  );
}

export default ApplicationStatus;